module.exports = "Please select a Sales Rep\r\n\r\n<select\r\n    style=\"margin-top: 20px;\"\r\n    class=\"form-control\"\r\n    ng-options=\"(item.firstName + ' ' + item.lastName) for item in locationUsers track by item.userId\"\r\n    ng-model=\"selectedUser\">\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/templates/webEnquiry/assignWebEnquiry.html
// module id = 1939
// module chunks = 0